/* global: DocumentTouch:true  */

(function () {
	'use strict';	
	var FormProgress = (function(){
		var isTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		var $prog	= $('.form-progress'),
			$trig	= $prog.find('.inds, h4'),
			$uTicks	= $prog.find('.user-tick'),
		
		init = function() {
			
			$uTicks.on('click', function(){
				/*jshint ignore:start */
				( $(this).hasClass('complete') ) ? $(this).removeClass('complete') : $(this).addClass('complete');
				/*jshint ignore:end */
			});
			
			if( isTouch ) { 
				$trig.on('touchend', function(e) {
					/*jshint ignore:start */
					($prog.hasClass('active')) ? $prog.removeClass('active') : $prog.addClass('active');
					/*jshint ignore:end */
					e.preventDefault();
					return false;
				});
			}
			
		};
		
		return { init: init };
		
	}());
	$(document).ready(function(){
		FormProgress.init();
	});
}());